import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=36ad847e"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=36ad847e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports